module.exports = __webpack_public_path__ + "static/media/NightVector.24188868.svg";